export default {
  notificationConfig: null
}
